import { render, staticRenderFns } from "./TheDashboardNavbarVertical.vue?vue&type=template&id=079e1bb6"
import script from "./TheDashboardNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheDashboardNavbarVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports